/**
 * version.js — user-facing app/PWA build version.
 *
 * These three exports are AUTO-STAMPED on every production build by
 * scripts/stamp-build-version.js (wired into craco.config.js). The committed
 * values below are the dev/fallback values used when the stamp step has not
 * run (e.g. local `craco start`). Keep the line format stable — the stamp
 * script rewrites these exact lines via regex.
 */
export const APP_VERSION = 'v273';
export const BUILD_TIME = '2026-11-02 15:16';
export const BUILD_ID = 'ng.20261102151612.nogit';
